import { render, staticRenderFns } from "./t-main.vue?vue&type=template&id=06bfd336&scoped=true&"
import script from "./t-main.vue?vue&type=script&lang=js&"
export * from "./t-main.vue?vue&type=script&lang=js&"
import style0 from "./t-main.vue?vue&type=style&index=0&id=06bfd336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bfd336",
  null
  
)

export default component.exports